import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var TitleCell = /*#__PURE__*/function (_Vue) {
  function TitleCell() {
    var _this;
    _classCallCheck(this, TitleCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TitleCell, [].concat(args));
    _defineProperty(_this, "image", void 0);
    _defineProperty(_this, "title", void 0);
    return _this;
  }
  _inherits(TitleCell, _Vue);
  return _createClass(TitleCell);
}(Vue);
__decorate([Prop({
  default: ""
})], TitleCell.prototype, "image", void 0);
__decorate([Prop({
  default: ""
})], TitleCell.prototype, "title", void 0);
TitleCell = __decorate([Options({
  components: {}
})], TitleCell);
export default TitleCell;